import { CommonModule } from '@angular/common';
import { Component, HostListener, input } from '@angular/core';
import { Overlay, OverlayService } from '~/app/services/overlay.service';

@Component({
  selector: 'gplus-overlay',
  imports: [CommonModule],
  templateUrl: './overlay.component.html',
  styleUrl: './overlay.component.scss'
})
export class OverlayComponent {
  public overlay = input<Overlay>(null);

  @HostListener('document:click')
  onClick() {
    if (this.overlayService.overlay()?.open) {
      this.overlayService.close();
    }
  }

  constructor(private readonly overlayService: OverlayService) {}
}
